<template>
  <section>
    <div
      v-for="(requisiteCondition,index) in value"
      :key="index"
    >
      <RequisiteAdvanceConditions
        :value="requisiteCondition"
        :level="level"
      />
    </div>
  </section>
</template>

<script>
import RequisiteAdvanceConditions from './RequisiteAdvanceConditions'

export default {
  components: {
    RequisiteAdvanceConditions,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    level: {
      type: Number,
      default: 0,
    },
  },
}
</script>
